import React, {useContext, useMemo} from "react";
import PropTypes from "prop-types";
import context from "components/Shared/MSidebar/utility/context";

const DrawerItemRightSide = ({children}) => {
  const {open} = useContext(context);
  const className = useMemo(
    () => open 
      ? "DrawerItemRightSide-Visible"
      : "DrawerItemRightSide-Hidden",
    [open]
  );
  return (
    <div className={`DrawerItemRightSide-Root ${className}`}>
      {children}
    </div>
  );
};

DrawerItemRightSide.propTypes = {
  children: PropTypes.node,
};

export default DrawerItemRightSide;